// React/Router Core
import { Routes, Route } from 'react-router-dom';
import { useState } from 'react';

// Layout & Navigation
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import links from './navigation';
import cx from 'classnames';

// Global Styles
import './index.scss';

// --- Dashboard & Home
import Dashboard from './pages/Dashboard/Dashboard';


// --- User & Auth
import { CreateUser, EditUser, UserList } from './pages/Users';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';

// --- Orders & Documents
import OrdersList from './pages/Orders/ListOrder/OrdersList';
import SingleOrder from './pages/Orders/SingleOrder/SingleOrder';
import CreateOrder from './pages/Orders/CreateOrder';
import EditOrder from './pages/Orders/EditOrder/EditOrder';
import OrderDocumentsList from './pages/OrderDocuments/OrderDocumentsList';
import OrderDocumentsCreate from './pages/OrderDocuments/OrderDocumentsCreate';

// --- Products & Categories
import ProductList from './pages/Product/ProductList';
import CreateProduct from './pages/Product/CreateProduct';
import EditProduct from './pages/Product/EditProduct';
import SingleProduct from './pages/Product/SingleProduct';

import CategoryList from './pages/Category/CategoryList';
import CreateCategory from './pages/Category/CreateCategory';
import EditCategory from './pages/Category/EditCategory';

// --- Features, Attributes, Addons, Filters
import CreateFeature from './pages/Feature/CreateFeature';
import EditFeature from './pages/Feature/EditFeature';
import FeatureList from './pages/Feature/FeatureList';

import CreateAttribute from './pages/Attribute/CreateAttribute';
import EditAttribute from './pages/Attribute/EditAttribute';
import AttributeList from './pages/Attribute/AttributeList';

import CreateAddon from './pages/Addon/CreateAddon';

import CreateFilter from './pages/Filter/CreateFilter';
import EditFilter from './pages/Filter/EditFilter';
import FilterList from './pages/Filter/FilterList';

// --- Projects & Configurations
import CreateProject from './pages/Project/CreateProject';
import EditProject from './pages/Project/EditProject';
import ProjectList from './pages/Project/ProjectList';

import ConfigurationPage from './pages/Configuration/ConfigurationPage';

// --- Rent Periods
import CreateRentPeriod from './pages/RentPeriod/CreateRentPeriod';
import EditRentPeriod from './pages/RentPeriod/EditRentPeriod';
import RentPeriodList from './pages/RentPeriod/RentPeriodList';

// --- Storage Management (Skladište)
import StorageRoomList from './pages/Storage/StorageRoomList';
import CreateStorageRoom from './pages/Storage/CreateStorageRoom';
import EditStorageRoom from './pages/Storage/EditStorageRoom';

import StorageStandList from './pages/Storage/StorageStandList';
import CreateStorageStand from './pages/Storage/CreateStorageStand';
import EditStorageStand from './pages/Storage/EditStorageStand';

// --- Activity Log & Not Found
import ActivityLog from './pages/ActivityLog';
import NotFoundAdmin from '../pages/NotFound/NotFoundAdmin';
// --- Media Library
import MediaLibraryPage from './pages/MediaLibrary/MediaLibraryPage';

function Admin() {
  const [collapsedSidebar, setCollapsedSidebar] = useState<boolean>(false);

  return (
    <main
      className={cx(
        'cs-admin-layout-wrapper',
        collapsedSidebar ? 'collapsed' : null
      )}
    >
      <div className="cs-header">
        <Header></Header>
      </div>
      <div className="cs-sidebar">
        <Sidebar
          collapsed={collapsedSidebar}
          setCollapsed={setCollapsedSidebar}
          links={links}
        ></Sidebar>
      </div>
      <div className="cs-content-wrapper">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/media-library" element={<MediaLibraryPage />} />
          <Route path="/configurations" element={<ConfigurationPage />} />
          <Route path="/rent-periods/create" element={<CreateRentPeriod />} />
          <Route path="/rent-periods/edit/:id" element={<EditRentPeriod />} />
          <Route path="/rent-periods/list" element={<RentPeriodList />} />
          <Route path="/user/create" element={<CreateUser />} />
          <Route path="/user/edit/:id" element={<EditUser />} />
          <Route path="/user/list" element={<UserList />} />
          <Route path="/projects/create" element={<CreateProject />} />
          <Route path="/projects/edit/:id" element={<EditProject />} />
          <Route path="/projects/list" element={<ProjectList />} />
          <Route path="/categories/create" element={<CreateCategory />} />
          <Route path="/categories/edit/:id" element={<EditCategory />} />
          <Route path="/categories/list" element={<CategoryList />} />
          <Route path="/filters/create" element={<CreateFilter />} />
          <Route path="/filters/edit/:id" element={<EditFilter />} />
          <Route path="/filters/list" element={<FilterList />} />
          <Route path="/attributes/create" element={<CreateAttribute />} />
          <Route path="/attributes/edit/:id" element={<EditAttribute />} />
          <Route path="/attributes/list" element={<AttributeList />} />
          <Route path="/features/create" element={<CreateFeature />} />
          <Route path="/features/edit/:id" element={<EditFeature />} />
          <Route path="/features/list" element={<FeatureList />} />
          <Route path="/addons/create" element={<CreateAddon />} />
          {/* PRODUCT */}
          <Route path="/products/create" element={<CreateProduct />} />
          <Route path="/products/edit/:id" element={<EditProduct />} />
          <Route path="/products/list" element={<ProductList />} />
          <Route path="/product/:id" element={<SingleProduct />} />
          {/* Storage Room */}
          <Route path="/storage-rooms/list" element={<StorageRoomList />} />
          <Route path="/storage-rooms/create" element={<CreateStorageRoom />} />
          <Route path="/storage-rooms/edit/:id" element={<EditStorageRoom />} />
          // Storage Stand
          <Route path="/storage-stands/list" element={<StorageStandList />} />
          <Route
            path="/storage-stands/create"
            element={<CreateStorageStand />}
          />
          <Route
            path="/storage-stands/edit/:id"
            element={<EditStorageStand />}
          />
          <Route path="/orders/*">
            <Route index element={<OrdersList />} />
            <Route path=":id" element={<SingleOrder />} />
            <Route path=":id/edit" element={<EditOrder />} />
            <Route path="create" element={<CreateOrder />} />
          </Route>
          <Route path="/order-documents/*">
            <Route index element={<OrderDocumentsList />} />
            <Route path="create" element={<OrderDocumentsCreate />} />
          </Route>
          <Route path="/activity-log" element={<ActivityLog />} />
          <Route
            element={
              <ProtectedRoute
                gate={(user) => {
                  return !!user && user.hasAnyRole(['superuser']);
                }}
              />
            }
          >
            <Route path="/super" element={<OrdersList />} />
          </Route>
          <Route path="*" element={<NotFoundAdmin />} />
        </Routes>
      </div>
    </main>
  );
}

export default Admin;
